import { Label } from 'src/legacy_graphql'
import useAccount from './useAccount'

type UserLabelKeys =
  | 'zeroPoint'
  | 'affiliate'
  | 'staff'
  | 'productLaunch'
  | 'giftingCommittee'
  | 'nowsiteActive'
  | 'nowsiteNeedSetup'
  | 'affiliateMissingW9'
  | 'affiliateMissingW8'
  | 'needsGsAffiliateOptIn'
  | 'needsCustomerReferralOptIn'
  | 'shouldHideRevolutionOffice'
  | 'gsaSubscriptionPaymentFailure'
  | 'priorAffiliate'
  | 'hasInvalidEmail'
  | 'hasDuplicateEmail'
  | 'hasDuplicateEmailClaimed'
  | 'hasFreeCampaignStore'
  | 'hasRelationshipMarketing'

type UserLabels = { readonly [Key in UserLabelKeys]: boolean }

const useUserLabels = (): UserLabels => {
  const account = useAccount()
  const labels = account.labels

  return {
    zeroPoint: labels.includes(Label.ZERO_POINT),
    affiliate: labels.includes(Label.AFFILIATE),
    staff: labels.includes(Label.STAFF),
    productLaunch: labels.includes(Label.PRODUCT_LAUNCH),
    giftingCommittee: labels.includes(Label.GIFTING_COMMITTEE),
    nowsiteActive: labels.includes(Label.NOWSITE_ACTIVE),
    nowsiteNeedSetup: labels.includes(Label.NOWSITE_NEED_SETUP),
    affiliateMissingW9: labels.includes(Label.AFFILIATE_MISSING_W9),
    affiliateMissingW8: labels.includes(Label.AFFILIATE_MISSING_W8),
    needsGsAffiliateOptIn: labels.includes(Label.NEEDS_GS_AFFILIATE_OPT_IN),
    needsCustomerReferralOptIn: labels.includes(
      Label.NEEDS_CUSTOMER_REFERRAL_OPT_IN,
    ),
    shouldHideRevolutionOffice: labels.includes(
      Label.SHOULD_HIDE_REVOLUTION_OFFICE,
    ),
    gsaSubscriptionPaymentFailure: labels.includes(
      Label.GSA_SUBSCRIPTION_PAYMENT_FAILURE,
    ),
    priorAffiliate: labels.includes(Label.PRIOR_AFFILIATE),
    hasInvalidEmail: labels.includes(Label.HAS_INVALID_EMAIL),
    hasDuplicateEmail: labels.includes(Label.HAS_DUPLICATE_EMAIL),
    hasDuplicateEmailClaimed: labels.includes(
      Label.HAS_DUPLICATE_EMAIL_CLAIMED,
    ),
    hasFreeCampaignStore: labels.includes(Label.HAS_FREE_CAMPAIGN_STORE),
    hasRelationshipMarketing: labels.includes(Label.HAS_RELATIONSHIP_MARKETING),
  }
}

export default useUserLabels
